<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">
<div class="row">

    <h2 class="col-sm-12 text-center" style="background-color: black; color: white; padding: 10px;">Report an issue</h2>

    <div class="col-sm-12 text-center">
      <form (ngSubmit)="onSubmit()" #f="ngForm">
        <div>
          <mat-form-field  appearance="fill" style="width: 100%;">
            <mat-label>Title</mat-label>
            <input matInput [(ngModel)]="title"  autocomplete="off"
            name="title" required  #title_="ngModel">
            <mat-error *ngIf="title_.errors">
              Title is required
            </mat-error>
          </mat-form-field>
        </div>


        <div>
          <mat-form-field  appearance="fill" style="width: 100%;">
          <mat-label>Your Contact Email</mat-label>
          <input matInput [(ngModel)]="contactEmail"  autocomplete="off"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          name="contactEmail" required  #contactEmail_="ngModel">
          <mat-error *ngIf="contactEmail_.errors">
            Contact email is required in correct format
          </mat-error>
        </mat-form-field>
        </div>

        <div>
          <mat-form-field class="system-units" appearance="fill" style="width: 100%;">
            <mat-label>Description</mat-label>
            <textarea matInput
             name="description" id="description" [(ngModel)]="description"
             #description_="ngModel" autocomplete="off" required
             cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="100">
            </textarea>
            <mat-error *ngIf="description_.errors">
              Description is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="text-center" id="buttons">
            <button mat-raised-button  color="primary"  type="submit" [disabled]="!f.valid || sendMailFlag" >
              Send Email
            </button>
            <button  mat-raised-button color="warn" style="color: white;min-width: 10%; border: none; font-weight: bold;"
                (click)="onNoClick()">Cancel
            </button>
        </div>

      </form>
    </div>
  </div>

</div>


